/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_kpi_disciplines14 = /** @type {(inputs: {}) => string} */ () => {
	return `Disciplines`
};

const fr_kpi_disciplines14 = /** @type {(inputs: {}) => string} */ () => {
	return `Disciplines`
};

const de_kpi_disciplines14 = /** @type {(inputs: {}) => string} */ () => {
	return `Disziplinen`
};

const es_kpi_disciplines14 = /** @type {(inputs: {}) => string} */ () => {
	return `Disciplinas`
};

const it_kpi_disciplines14 = /** @type {(inputs: {}) => string} */ () => {
	return `Discipline`
};

const ar_kpi_disciplines14 = /** @type {(inputs: {}) => string} */ () => {
	return `التخصصات`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const kpi_disciplines14 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.kpi_disciplines14(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("kpi_disciplines14", locale)
	if (locale === "en") return en_kpi_disciplines14(inputs)
	if (locale === "fr") return fr_kpi_disciplines14(inputs)
	if (locale === "de") return de_kpi_disciplines14(inputs)
	if (locale === "es") return es_kpi_disciplines14(inputs)
	if (locale === "it") return it_kpi_disciplines14(inputs)
	return ar_kpi_disciplines14(inputs)
};
export { kpi_disciplines14 as "KPI_DISCIPLINES" }